import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  access_token: null,
  loading: false,
  error: null,
  message: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart(state) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },
    loginSuccess(state, action) {
      state.loading = false;
      state.user = action.payload.user;
      state.access_token = action.payload.access_token;
      state.message = action.payload.message;
      state.error = null;
    },
    loginFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.user = null;
      state.access_token = null;
    },
    resetPasswordStart(state) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },
    resetPasswordSuccess(state, action) {
      state.loading = false;
      state.message = action.payload.message;
      state.error = null;
    },
    resetPasswordFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    logout(state) {
      state.user = null;
      state.access_token = null;
      state.message = null;
      state.error = null;
    },
    setTwoFAEnabled(state, action) {
      if (state.user) {
        state.user = {
          ...state.user,
          twoFA: { ...(state.user.twoFA || {}), enabled: action.payload },
        };
      }
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  resetPasswordStart,
  resetPasswordSuccess,
  resetPasswordFailure,
  logout,
  setTwoFAEnabled,
} = authSlice.actions;

// Thunk for logout (no API call, just clear state)
export const logoutUser = () => (dispatch) => {
  dispatch(logout());
};

export default authSlice.reducer; 